const KeenSlider = window.KeenSlider

const { getOffsetTop } = window.BAO.Utils
const { setInitialised } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return
    if (this.els.slide.elements.length <= 1) return

    this.carousel = this.setupCarousel()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.slide?.exists) return
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
        slideChanged: (instance) => {
          if (!this.els?.counter?.exists) return

          this.els.counter.element.textContent = instance.track.details.abs + 1
        },
      },
      [setInitialised()],
    )
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveParallaxItem()
  }

  moveParallaxItem () {
    if (!this.offsetHeight) return
    if (!window.BAO.MediaBreakpoints.isMd) return

    const maxAmountToRotate = 3
    const maxAmountToMove = 50

    const mediaEls = this.querySelectorAll(
      '[data-product-media-el="slide"]:not(.prd-Media_Item-hidden)',
    )

    mediaEls.forEach((mediaEl) => {
      const distanceToScroll = window.innerHeight / 2

      const elementStartPoint = getOffsetTop(mediaEl) - window.innerHeight
      const elementEndPoint = elementStartPoint + distanceToScroll

      if (this.lastKnownY <= elementStartPoint) {
        mediaEl.style.setProperty(
          '--Slide_Transform',
          `rotate(${maxAmountToRotate}deg) translateY(${maxAmountToMove}px)`,
        )

        return
      }

      if (this.lastKnownY > elementEndPoint) {
        mediaEl.style.setProperty(
          '--Slide_Transform',
          `rotate(0deg) translateY(0px)`,
        )

        return
      }

      const totalScrollAmount = elementEndPoint - elementStartPoint

      const scrollYAsAPercentageOfJourney =
        (this.lastKnownY - elementStartPoint) / totalScrollAmount

      const rotateAmount =
        maxAmountToRotate - maxAmountToRotate * scrollYAsAPercentageOfJourney

      const moveAmount =
        maxAmountToMove - maxAmountToMove * scrollYAsAPercentageOfJourney

      mediaEl.style.setProperty(
        '--Slide_Transform',
        `rotate(${rotateAmount}deg) translateY(${moveAmount}px)`,
      )
    })
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
